var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isOverView()
        ? _c("overview")
        : _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.title))])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }